const CACHE_KEY = 'panelfox_storage_account_panel_columns';

export const panelColumnsCache = {
    /**
     * Retrieves the value stored in the browser's global window object under a specific key.
     *
     * @function
     * @returns {*} The value associated with the CACHE_KEY in the window object, or undefined if the key does not exist.
     */
    get: () => window[CACHE_KEY],
    /**
     * Sets the provided data into a global cache using a predefined key.
     * The data is stored as a property of the global `window` object.
     *
     * @function
     * @param {*} data - The data to be stored in the cache.
     */
    set: data => {
        window[CACHE_KEY] = data;
    },
    /**
     * Deletes a global cache entry in the `window` object using the specified CACHE_KEY.
     * This function assumes that `CACHE_KEY` is a predefined constant or variable
     * that corresponds to the key of the cache object in the `window` object.
     *
     * @function
     */
    delete: () => {
        delete window[CACHE_KEY];
    }
};
